const action = "SEGMENT_EDIT";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const FAILURE = action+'_FAILURE';
export const CLEAR = action+'_CLEAR';

export const editSegmentRequest = (segmentId, payload) => {
    return {
        type: REQUEST,
        segmentId,
        payload
    };
};

export const editSegmentSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const editSegmentFailure = (error) => ({
  type: FAILURE,
  payload: error
});

export const clearState = () => ({
  type: CLEAR
}); 